import { connect } from 'react-redux';
import {
  activateAuthorizations,
  authorizationsToActivate,
  authorizationsToDeactivate,
  deactivateAuthorizations,
  deleteCustomerAuthorizations,
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorizationToActivate,
  setCustomerAuthorizationToDelete,
} from './store/customerAuthorizationSlice';
import CustomerAuthorizations from './CustomerAuthorizations';

const mapState = state => ({
  authorizationsToActivate: authorizationsToActivate(state),
  authorizationsToDeactivate: authorizationsToDeactivate(state),
  confirmDialogType: state.loadingManagement.customerAuthorizations.confirmDialogType,
  customerAuthorizationId: state.loadingManagement.customerAuthorizations.customerAuthorizationId,
  customerAuthorizationToActivate:
    state.loadingManagement.customerAuthorizations.customerAuthorizationToActivate,
  customerAuthorizationToDeactivate:
    state.loadingManagement.customerAuthorizations.customerAuthorizationToDeactivate,
  customerAuthorizationToDelete:
    state.loadingManagement.customerAuthorizations.customerAuthorizationToDelete,
  isActivationDialogOpen: state.loadingManagement.customerAuthorizations.isActivationDialogOpen,
  isConfirmDialogOpen: state.loadingManagement.customerAuthorizations.isConfirmDialogOpen,
  selectedAuthorizations: state.loadingManagement.customerAuthorizations.selectedAuthorizations,
});

const mapDispatchToProps = {
  activateAuthorizations,
  deactivateAuthorizations,
  deleteCustomerAuthorizations,
  setActivationDialogOpen,
  setConfirmDialogOpen,
  setConfirmDialogType,
  setCustomerAuthorizationToActivate,
  setCustomerAuthorizationToDelete,
};

export default connect(mapState, mapDispatchToProps)(CustomerAuthorizations);
